import { useEffect,useState, useContext } from 'react';
import { TextField, Button, Card, CardContent, Typography, Box, CircularProgress, Autocomplete } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LoadToCosmos,SendToCosmos } from './SendToCosmos';
import { saveToCache, loadFromCacheAll } from './CacheHandler';
import { ModeContext } from './ModeContext';
import { useMsal } from '@azure/msal-react';
import { FaWindows } from 'react-icons/fa'; // ← MUIのWindows風アイコン

const LoginPage = () => {
  const { instance } = useMsal();
  const [compId, setCompId] = useState('');
  const [userId, setUserId] = useState('');
  const [compIdHistory, setCompIdHistory] = useState([]);
  const [userIdHistory, setUserIdHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [version, setVersion] = useState('');
  const navigate = useNavigate();
  const { setChatHistory, setLoginInfo, setDisplayMode, setActiveButton, setIsUploadMode } = useContext(ModeContext);

  // localStorageから過去の入力履歴を読み込む
  useEffect(() => {
    try {
      const savedCompIds = JSON.parse(localStorage.getItem('compIdHistory')) || [];
      const savedUserIds = JSON.parse(localStorage.getItem('userIdHistory')) || [];
      setCompIdHistory(savedCompIds);
      setUserIdHistory(savedUserIds);
    } catch {
      setCompIdHistory([]);
      setUserIdHistory([]);
    }
  }, []);

  // meta.jsonからバージョン情報を取得
  useEffect(() => {
    fetch(`/meta.json?t=${Date.now()}`)
      .then(response => response.json())
      .then(data => setVersion(data.version))
      .catch(() => setVersion(''));
  }, []);


  const handleLogin = async (e) => {
    e.preventDefault();
    if (!compId || !userId) {
      alert('顧客IDとユーザー名を入力してください');
      return;
    }

    console.log("顧客ID:", compId);
    console.log("ユーザーID:", userId);

    setLoading(true);
    document.body.style.cursor = 'wait';

    const uppayload = {
      compId: compId,
      userId: userId,
      container: "con-concierge-user"
    };

    try {
      //ユーザー認証
      const item = await LoadToCosmos(uppayload);

      if (item && Object.keys(item).length > 0) {
        // 入力履歴を保存（重複排除、最大5件）
        const updateHistory = (key, value) => {
          let history = JSON.parse(localStorage.getItem(key)) || [];
          history = [value, ...history.filter(v => v !== value)].slice(0, 5);
          localStorage.setItem(key, JSON.stringify(history));
          return history;
        };
        setCompIdHistory(updateHistory('compIdHistory', compId));
        setUserIdHistory(updateHistory('userIdHistory', userId));

        localStorage.setItem('id', item.item.id);
        localStorage.setItem('compId', item.item.compId);
        localStorage.setItem('compName', item.item.compName);
        localStorage.setItem('userId', item.item.userId);
        localStorage.setItem('userName', item.item.userName);
        localStorage.setItem('authorityId', item.item.authorityId);
        localStorage.setItem('isLoggedIn', 'true');
        localStorage.setItem('groupId', item.item.groupId);

        const groupId = item?.item?.groupId ?? null;
        const pro_payload = {
          compId: groupId ? `${compId}-${groupId}` : compId,
          container: "con-concierge-prompt"
        };
        //プロンプト取得
        const pro_item = await LoadToCosmos(pro_payload);
        let prompt
        let data
        let faqapi
        let webhook

        if (pro_item && Object.keys(pro_item).length > 0) {
          prompt = pro_item.item.messages
          data = pro_item.item.data
          faqapi = pro_item.item.faqapi
          webhook = pro_item.item.webhook
          //prompt = pro_item.item.messages
          //data = pro_item.item.data
 
          localStorage.setItem('prompt', JSON.stringify(prompt));
          localStorage.setItem('data', JSON.stringify(data));
          localStorage.setItem('faqapi', JSON.stringify(faqapi));
          localStorage.setItem('webhook',JSON.stringify(webhook));

        }else{
          prompt = 'none'
          data = 'none'
          faqapi = 'none'
          webhook = 'none'
        }

        // ContextのloginInfoにisLoggedInフラグを含めて更新
        setLoginInfo({ ...item.item,
          prompt: prompt ,
          data: data ,
          faqapi: faqapi ,
          isLoggedIn: true,
          webhook: webhook
        });

        // チャット画面の初期状態に設定
        setDisplayMode('chat');
        setActiveButton('chat');
        setIsUploadMode(false);

        // キャッシュに履歴とファイルリストを保存
        await Promise.all([
          loadAndSaveToCache('con-concierge-hist', 'chat-history-cache', setChatHistory),
          loadAndSaveToCache('con-concierge-file', 'chat-file-cache')
        ]);

        // チャット画面に遷移
        navigate('/');
      } else {
        alert('顧客IDまたはユーザー名が正しくありません');
      }
    } catch (error) {
      console.error("ログイン中にエラーが発生しました:", error);
      alert('エラーが発生しました。');
    } finally {
      setLoading(false); // ローディング終了
      document.body.style.cursor = 'default'; 
    }
  };


const handleSSOLogin = async () => {
  try {
    setLoading(true);
    document.body.style.cursor = 'wait';
    const response = await instance.loginPopup({
      scopes: ["User.Read"],
    });
//    console.log("Microsoftアカウントでログイン成功:", response);

    // ユーザー情報（例: emailなど）取得
    const account = response.account;
    const ssoUserId = account.username;//アドレス
    const ssoName = account.name;//名前

    let uppayload = {}
    uppayload = {
      id:"sso",
      userId: ssoUserId,
      container: "con-concierge-user"
    }; 
    //ユーザー認証
    let item = await LoadToCosmos(uppayload); 

    //ユーザーは既に登録されている
    if (item && Object.keys(item).length > 0) {
    } else {
      //SSOでユーザーがない場合はユーザーをCosmosに登録する
      let useruppayload = {
        id: `999999-${ssoUserId}`,
        compId: '999999',
        compName: '寺岡精工',
        userId: ssoUserId,
        userName: ssoName,
        authorityId: 'admin',
        container: "con-concierge-user"
      };
      await SendToCosmos(useruppayload);


    }
    item = await LoadToCosmos(uppayload);
    localStorage.setItem('id', item.item.id);
    localStorage.setItem('compId', item.item.compId);
    localStorage.setItem('compName', item.item.compName);
    localStorage.setItem('userId', item.item.userId);
    localStorage.setItem('userName', item.item.userName);
    localStorage.setItem('authorityId', item.item.authorityId);
    localStorage.setItem('groupId', item.item.groupId);
    localStorage.setItem('isLoggedIn', 'true');
    
    const groupId = item?.item?.groupId ?? null;
//プロンプト読み込み
    const pro_payload = { 
        compId: groupId ? `${item.item.compId}-${groupId}` : item.item.compId,
        container: "con-concierge-prompt"
    };
    const pro_item = await LoadToCosmos(pro_payload);
    let prompt
    let data
    let faqapi
    let webhook
    if (pro_item && Object.keys(pro_item).length > 0) {
      prompt = pro_item.item.messages
      data = pro_item.item.data
      faqapi = pro_item.item.faqapi
      webhook = pro_item.item.webhook
      //prompt = pro_item.item.messages
      //data = pro_item.item.data
 
      localStorage.setItem('prompt', JSON.stringify(prompt));
      localStorage.setItem('data', JSON.stringify(data));
      localStorage.setItem('faqapi', JSON.stringify(faqapi));
      localStorage.setItem('webhook', JSON.stringify(webhook));      
    }

    setLoginInfo({ ...item.item,
          prompt: prompt ,
          data: data ,
          faqapi: faqapi ,
          isLoggedIn: true,
          webhook: webhook });

    // チャット画面の初期状態に設定
    setDisplayMode('chat');
    setActiveButton('chat');
    setIsUploadMode(false);

    await Promise.all([
          loadAndSaveToCache('con-concierge-hist', 'chat-history-cache', setChatHistory, item.item.compId, item.item.userId),
          loadAndSaveToCache('con-concierge-file', 'chat-file-cache', undefined, item.item.compId, item.item.userId)
        ]);

    // チャット画面に遷移
    navigate('/');
  } catch (error) {
    console.error("SSOログイン失敗:", error);
  }finally {
    setLoading(false);                        
    document.body.style.cursor = 'default'; 
  }
};  
  
  // キャッシュへの保存処理を共通化
  const loadAndSaveToCache = async (container, cacheName, setState = null, wkcompId=null,wkuserId=null) => {
    let uppayload={}
    if (wkcompId && wkuserId) {
      uppayload = { compId:wkcompId , userId:wkuserId, container:container };
    } else if (wkuserId) {
      // SSO: compIdなし、userIdのみ
      uppayload = { userId:wkuserId, container:container };
    } else { 
      uppayload = { compId, userId, container };
    }

    const item = await LoadToCosmos(uppayload);

    if (!item || Object.keys(item).length === 0) return;

    if (setState) setState([]); // Optional: 状態のリセット

    for (const msg of item.item.messages) {
      await saveToCache(
        msg.id,
        cacheName,
        msg.title,
        msg.messages,
        msg.timestamp ?? Date.now(),
        msg.mode ?? '',
        setState
      );
    }

    if (setState) {
      const updatedHistory = await loadFromCacheAll(cacheName);
      setState(updatedHistory);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card" elevation={6} >
        <CardContent sx={{ px: { xs: 2, sm: 3 }, py: { xs: 2, sm: 3 } }}>
          <Typography variant="h5" component="div" gutterBottom sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>
            ログイン
          </Typography>

          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '150px' }}>
              情報取得中
              <CircularProgress sx={{ mr: 2 }} />
            </Box>
          ) : (
            <form onSubmit={handleLogin}>
              <Autocomplete
                freeSolo
                options={compIdHistory}
                inputValue={compId}
                onInputChange={(_, newValue) => setCompId(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="顧客ID"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />
                )}
              />
              <Autocomplete
                freeSolo
                options={userIdHistory}
                inputValue={userId}
                onInputChange={(_, newValue) => setUserId(newValue)}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="ユーザーID"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />
                )}
              />
              <Box display="flex" flexDirection="column" gap={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
                sx={{ marginTop: 2, fontWeight: "bold" }}
              >
                ログイン
              </Button>
    
              <Button
              variant="contained"
              color="primary"
              fullWidth
              startIcon={<FaWindows />}
              onClick={handleSSOLogin}
            >
              Microsoft アカウントでログイン
            </Button>
            </Box>
            {version && `Ver${version}`}
            </form>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default LoginPage;
